export const colors = [
    //'#035e97',
    '#006DB6',
    '#0D8CCD',
    '#9CCFFF',
    '#CBE3FA',
    '#E9770F',
    '#ED8D36',
    '#ECAA6E',
    '#F6C79B',
    '#FDDFC3',
    '#FDE9D4', //'#154579',
];
